import * as React from 'react';
import { cn } from '../../lib/utils';
import { gridWidth } from './input';

export interface TextareaProps
  extends Omit<React.TextareaHTMLAttributes<HTMLTextAreaElement>, 'value'> {
  label?: React.ReactNode;
  error?: string | boolean;
  s?: number;
  m?: number;
  l?: number;
  inputClassName?: string;
  value?: React.TextareaHTMLAttributes<HTMLTextAreaElement>['value'] | null;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ label, error, s, m, l, className, inputClassName, id, disabled, value, ...props }, ref) => {
    const hasError = Boolean(error);
    const errorMessage = typeof error === 'string' ? error : undefined;

    return (
      <div className={cn('px-1', gridWidth(s, m, l), className)}>
        {label && (
          <label htmlFor={id} className="mb-1 block text-sm font-medium text-foreground">
            {label}
          </label>
        )}
        <textarea
          id={id}
          ref={ref}
          disabled={disabled}
          value={value === null ? '' : value}
          aria-invalid={hasError || undefined}
          className={cn(
            'flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm shadow-sm transition-colors',
            'placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring',
            'disabled:cursor-not-allowed disabled:opacity-50',
            hasError && 'border-destructive focus-visible:ring-destructive',
            inputClassName
          )}
          {...props}
        />
        {errorMessage && <p className="mt-1 text-xs text-destructive">{errorMessage}</p>}
      </div>
    );
  }
);
Textarea.displayName = 'Textarea';

export { Textarea };
